/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { UiButtonStyle_Enum, uiButtonStyle_EnumFromJSON, uiButtonStyle_EnumToJSON } from "./ui_button_style";

export const protobufPackage = "skills";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UiButton {
  id: string;
  label: string;
  detail: string;
  style: UiButtonStyle_Enum;
  disabled: boolean;
  iconId: string;
  confirmationTitle: string;
  confirmationMessage: string;
  pageId: string;
}

function createBaseUiButton(): UiButton {
  return {
    id: "",
    label: "",
    detail: "",
    style: 0,
    disabled: false,
    iconId: "",
    confirmationTitle: "",
    confirmationMessage: "",
    pageId: "",
  };
}

export const UiButton = {
  encode(message: UiButton, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.label !== "") {
      writer.uint32(18).string(message.label);
    }
    if (message.detail !== "") {
      writer.uint32(26).string(message.detail);
    }
    if (message.style !== 0) {
      writer.uint32(32).int32(message.style);
    }
    if (message.disabled === true) {
      writer.uint32(40).bool(message.disabled);
    }
    if (message.iconId !== "") {
      writer.uint32(50).string(message.iconId);
    }
    if (message.confirmationTitle !== "") {
      writer.uint32(58).string(message.confirmationTitle);
    }
    if (message.confirmationMessage !== "") {
      writer.uint32(66).string(message.confirmationMessage);
    }
    if (message.pageId !== "") {
      writer.uint32(74).string(message.pageId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UiButton {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUiButton();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.label = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.detail = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.style = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.iconId = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.confirmationTitle = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.confirmationMessage = reader.string();
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.pageId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UiButton {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      detail: isSet(object.detail) ? globalThis.String(object.detail) : "",
      style: isSet(object.style) ? uiButtonStyle_EnumFromJSON(object.style) : 0,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
      iconId: isSet(object.iconId) ? globalThis.String(object.iconId) : "",
      confirmationTitle: isSet(object.confirmationTitle) ? globalThis.String(object.confirmationTitle) : "",
      confirmationMessage: isSet(object.confirmationMessage) ? globalThis.String(object.confirmationMessage) : "",
      pageId: isSet(object.pageId) ? globalThis.String(object.pageId) : "",
    };
  },

  toJSON(message: UiButton): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.label !== "") {
      obj.label = message.label;
    }
    if (message.detail !== "") {
      obj.detail = message.detail;
    }
    if (message.style !== 0) {
      obj.style = uiButtonStyle_EnumToJSON(message.style);
    }
    if (message.disabled === true) {
      obj.disabled = message.disabled;
    }
    if (message.iconId !== "") {
      obj.iconId = message.iconId;
    }
    if (message.confirmationTitle !== "") {
      obj.confirmationTitle = message.confirmationTitle;
    }
    if (message.confirmationMessage !== "") {
      obj.confirmationMessage = message.confirmationMessage;
    }
    if (message.pageId !== "") {
      obj.pageId = message.pageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UiButton>, I>>(base?: I): UiButton {
    return UiButton.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UiButton>, I>>(object: I): UiButton {
    const message = createBaseUiButton();
    message.id = object.id ?? "";
    message.label = object.label ?? "";
    message.detail = object.detail ?? "";
    message.style = object.style ?? 0;
    message.disabled = object.disabled ?? false;
    message.iconId = object.iconId ?? "";
    message.confirmationTitle = object.confirmationTitle ?? "";
    message.confirmationMessage = object.confirmationMessage ?? "";
    message.pageId = object.pageId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
